var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3844 11.3617L7.89375 3.11167C7.78018 3.04162 7.64998 3.00313 7.51658 3.00018C7.38318 2.99723 7.25141 3.02993 7.13486 3.09489C7.0183 3.15985 6.92119 3.25473 6.85354 3.36975C6.78589 3.48476 6.75015 3.61574 6.75 3.74917V20.2492C6.75015 20.3826 6.78589 20.5136 6.85354 20.6286C6.92119 20.7436 7.0183 20.8385 7.13486 20.9035C7.25141 20.9684 7.38318 21.0011 7.51658 20.9982C7.64998 20.9952 7.78018 20.9567 7.89375 20.8867L21.3844 12.6367C21.4952 12.5712 21.5869 12.4779 21.6507 12.3661C21.7145 12.2543 21.748 12.1279 21.748 11.9992C21.748 11.8705 21.7145 11.744 21.6507 11.6322C21.5869 11.5204 21.4952 11.4272 21.3844 11.3617V11.3617Z",
    stroke: "#3030AD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play.34f35c6c1de8b98d2f249a8a1ce8c01e.svg";